/**
 * H5 参会端：父视图（PTT / banner / TTS）与子组件（Feed）共享的控制面
 */

import type { InjectionKey, Ref } from 'vue'

export interface CrV3H5Controls {
  pttHolding: Ref<boolean>
  floorBlocked: Ref<boolean>
  speakAllowed: Ref<boolean>
  startPtt: () => void
  stopPtt: () => void
  /** designated 模式下由授权（liveSpeech）自动触发的拾音，而非手动按住（D19-speak H5） */
  autoCaptureActive: Ref<boolean>
  /** 听者 TTS 开关（默认关） */
  ttsEnabled: Ref<boolean>
  setTtsEnabled: (value: boolean) => void
  /** 当前 PTT 源语种 sttSupported=false 时为 true（禁用发言） */
  listenSttUnsupported?: Ref<boolean>
}

export const crV3H5ControlsKey: InjectionKey<CrV3H5Controls> = Symbol('cr-v3-h5-controls')
